'use client';
import { useEffect, useState, useRef } from 'react';
import useLocale from '@/hooks/useLocale';
import { shouldUseTrustedShopsReviews } from '@/utils/helpers';
import { getTrustedShopsId } from '@/utils/trustedShopsHelpers';

export const useTrustedShopsScript = () => {
  const [scriptsLoaded, setScriptsLoaded] = useState(false);
  const initialized = useRef(false);
  const locale = useLocale();

  useEffect(() => {
    const loadScriptsSequentially = async () => {
      const tsId = getTrustedShopsId(locale as string);

      const scriptUrls = [
        `https://widgets.trustedshops.com/js/${tsId}.js`,
        'https://integrations.etrusted.com/applications/widget.js/v2',
      ];

      for (const scriptUrl of scriptUrls) {
        await loadScript(scriptUrl);
      }
      setScriptsLoaded(true);
    };

    if (
      shouldUseTrustedShopsReviews() &&
      !initialized.current &&
      !window.trustbadge &&
      !scriptsLoaded
    ) {
      initialized.current = true;
      loadScriptsSequentially();
    }
  }, [scriptsLoaded, locale]);
};

export function loadScript(src: string) {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');

    script.src = src;
    script.async = true;

    script.onload = () => {
      resolve();
    };

    script.onerror = (error) => {
      reject(error);
    };

    script.dataset.desktopPosition = 'left';
    script.dataset.mobilePosition = 'left';

    document.body.appendChild(script);
  });
}
